import { RestClientService } from '../rest-client.service';
import { Location } from '@angular/common';
import { environment } from '../../environments/environment';
import { catchError, switchMap } from 'rxjs/operators';
import { ObservableResult } from '../../models/result.model';
import { ResourcesDataService } from './resources-data.service';
import {
  ResourceSalutation,
  ResourceCountry,
  ResourceLanguage,
  ResourceProvinces, ResourceCurrencies, ResourceIsoLanguage
} from '../../models/resources/resources.model';

export class ApiResourcesDataService implements ResourcesDataService {

  constructor(
    private client: RestClientService
  ) {
  }


  getResourceCountries(): ObservableResult<ResourceCountry[]> {
    const url = Location.joinWithSlash(
      environment.apiRootUrl || '', '/contacts/do-request'
    );

    const request = {
      method: 'GET',
      uri: '/api/Resources/Countries'
    };

    return this.client.post<{ data: ResourceCountry[] }>(url, request).pipe(
      switchMap(({body}) => ObservableResult.ofSuccess(body.data.sort((a, b) => {
        if (a.IsPriority < b.IsPriority) {
          return 1;
        } else if (a.IsPriority > b.IsPriority) {
          return -1;
        } else if (a.Name > b.Name) {
          return 1;
        } else if (a.Name < b.Name) {
          return -1;
        }

        return 0;
      }))),
      catchError((err) => ObservableResult.ofError(err.error, err.status))
    );
  }

  getResourceLanguages(): ObservableResult<ResourceLanguage[]> {
    const url = Location.joinWithSlash(
      environment.apiRootUrl || '', '/contacts/do-request'
    );

    const request = {
      method: 'GET',
      uri: '/api/Resources/Languages'
    };

    return this.client.post<{ data: ResourceLanguage[] }>(url, request).pipe(
      switchMap(({body}) => ObservableResult.ofSuccess(body.data)),
      catchError((err) => ObservableResult.ofError(err.error, err.status))
    );
  }

  getResourceIsoLanguages(): ObservableResult<ResourceIsoLanguage[]> {
    const url = Location.joinWithSlash(
      environment.apiRootUrl || '', '/contacts/do-request'
    );

    const request = {
      method: 'GET',
      uri: '/api/Resources/IsoLanguages'
    };

    return this.client.post<{ data: ResourceIsoLanguage[] }>(url, request).pipe(
      switchMap(({body}) => ObservableResult.ofSuccess(body.data)),
      catchError((err) => ObservableResult.ofError(err.error, err.status))
    );
  }

  getResourceCurrencies(): ObservableResult<ResourceCurrencies[]> {
    const url = Location.joinWithSlash(
      environment.apiRootUrl || '', '/contacts/do-request'
    );

    const request = {
      method: 'GET',
      uri: '/api/Resources/Currencies'
    };

    return this.client.post<{ data: ResourceCurrencies[] }>(url, request).pipe(
      switchMap(({body}) => ObservableResult.ofSuccess(body.data)),
      catchError((err) => ObservableResult.ofError(err.error, err.status))
    );
  }

  getResourceSalutation(): ObservableResult<ResourceSalutation[]> {
    const url = Location.joinWithSlash(
      environment.apiRootUrl || '', '/contacts/do-request'
    );

    const request = {
      method: 'GET',
      uri: '/api/Contacts/ContactSalutations'
    };

    return this.client.post<{ data: ResourceSalutation[] }>(url, request).pipe(
      switchMap(({body}) => ObservableResult.ofSuccess(body.data)),
      catchError((err) => ObservableResult.ofError(err.error, err.status))
    );
  }

  getResourceProvinces(): ObservableResult<ResourceProvinces[]> {
    const url = Location.joinWithSlash(
      environment.apiRootUrl || '', '/contacts/do-request'
    );

    const request = {
      method: 'GET',
      uri: '/api/Resources/Provinces'
    };

    return this.client.post<{ data: any[] }>(url, request).pipe(
      switchMap(({body}) => ObservableResult.ofSuccess(body.data)),
      catchError((err) => ObservableResult.ofError(err.error, err.status))
    );
  }

  getResourcesTranslations(domain: string): ObservableResult<any> {
    const url = `/api/Resources/TranslationsAuth/${domain}`;
    const method = 'GET';

    return this.client.requestWithConstUrl<any>(method, url);
  }

  getResourcesTranslationsByLanguageCode(domain: string, languageCode: string): ObservableResult<any> {
    const url = `/api/Resources/Translations/${domain}/${languageCode}`;
    const method = 'GET';

    return this.client.requestWithConstUrl<any>(method, url);
  }
}
